import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 邮件模板（/v1/admin/email-templates/**）
 */

export function listEmailTemplates() {
  return axios.get(`${base.url}/service/v1/admin/email-templates`)
}

export function getEmailTemplate(id) {
  return axios.get(`${base.url}/service/v1/admin/email-templates/${id}`)
}

export function updateEmailTemplate(id, data) {
  return axios.put(`${base.url}/service/v1/admin/email-templates/${id}`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}